import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppComponent } from '../app.component';
import { UrlService } from '../model/url.service';
import { UniversalPlatformService } from '../shared/platform/universal-platform.service';
import { FbService } from '../shared/fb.service';
import { AutoUnsubscribe } from '../decorators/autounsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'app-social-share',
  templateUrl: './social-share.component.html',
})
export class SocialShareComponent implements AfterViewInit, OnDestroy {

  @Input()
  url: string;

  @Input()
  disableEmail: boolean;

  @Input()
  disableHeader: boolean;

  @Output()
  emailClick: EventEmitter<any> = new EventEmitter();

  private _fbRemoveSub: Subscription;
  private _fbInitializedSub: Subscription;
  private _fbRefreshedSub: Subscription;

  private _fbLikeEnabled: boolean;
  private _fbShareEnabled: boolean;

  constructor(
    public urlService: UrlService,
    private _platformService: UniversalPlatformService,
    private _app: AppComponent,
    private _fbService: FbService,
  ) {
    this._fbLikeEnabled = this._fbShareEnabled = _platformService.isBrowser;

    this._fbRemoveSub = _fbService.fbRemoved.subscribe(() => {
      this._fbLikeEnabled = false;
    });

    this._fbRefreshedSub = _fbService.fbRefreshed.subscribe(() => {
      this._fbLikeEnabled = this._fbShareEnabled = this._platformService.isBrowser;
      // this._fbService.parse();
    });

    this._fbInitializedSub = _fbService.initialized.subscribe((count) => {
      if (count > 0) {
        this._fbLikeEnabled = this._fbShareEnabled = this._platformService.isBrowser;

        if (this._fbInitializedSub) {
          this._fbInitializedSub.unsubscribe();
        }
      }
    });
  }

  get sharedUrl(): string {
    if (this.url && (this.url || []).length) {
      return this.url;
    }

    return this.urlService.getCurrentUrl();
  }

  get enableFbLike(): boolean {
    if (this._platformService.isBrowser) {
      return this._fbLikeEnabled;
    }

    return false;
  }

  ngAfterViewInit(): void {
    this._fbService.parse();
  }

  ngOnDestroy(): void {
    if (this._fbInitializedSub) {
      this._fbInitializedSub.unsubscribe();
    }

    this._fbRemoveSub.unsubscribe();
    this._fbRefreshedSub.unsubscribe();
  }

  onEmailClick(evt?: any): void {

    if (evt && evt.preventDefault) {
      evt.preventDefault();
    }

    this.emailClick.emit([]);
  }

  getSocialLink(portal: string, url?: string): string {
    const sharedUrl = url && (url || []).length ? url : this.sharedUrl;
    let link: string;

    switch (portal) {
      case 'facebook':
        link = 'https://www.facebook.com/sharer/sharer.php?u=';
        break;

      case 'twitter':
        link = 'https://twitter.com/home?status=';
        break;

      case 'pinterest':
        link = 'https://pinterest.com/pin/create/button/?media=&description=&url=';
        break;

      case 'googleplus':
        link = 'https://plus.google.com/share?url=';
        break;

      default:
        link = '';
    }

    if (!(link || []).length) {
      return link;
    }

    link += encodeURIComponent(sharedUrl);

    return link;
  }

}
